







































































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import Crumbs from "@/components/Crumbs/index.vue";
import { Input, Button, Modal } from "ant-design-vue";
import CList from "@/components/CList/index.vue";
import env from "@/config/env";

@Component({
  name: "ServiceHall",
  components: {
    CList,
    Crumbs,
    AInputSearch: Input.Search,
    AButton: Button,
    AModal: Modal
  }
})
export default class Notice extends Base {
  private contactVisible = false;
  private serviceType: any[] = [{ dictValue: "", dictLabel: "全部" }];
  private currentKey = "";
  private searchVal = "";
  private services: any[] = [];
  private contacts: any[] = [];

  private created() {
    this._created();
    this.getSystemDict();
    this.searchServiceRoom();
    this.serviceGetContactOur();
  }

  private changeType(obj: any) {
    this.currentKey = obj.dictValue;
    this.searchServiceRoom();
  }

  private async getSystemDict() {
    const res = await this.$api.SystemDict("service_type");
    if (res && res.code === 200) {
      this.serviceType = [...this.serviceType, ...res.data];
    }
  }

  private async initiSearchVal() {
    this.searchVal = "";
    this.searchServiceRoom();
  }

  private async searchServiceRoom() {
    const res = await this.$api.SearchServiceRoom({
      name: this.searchVal,
      serviceType: this.currentKey
    });

    if (res && res.code === 200) {
      this.services = res.data;
    }
  }

  private async serviceGetContactOur() {
    const res = await this.$api.ServiceGetContactOur();

    // 重组contacts
    if (res && res.code === 200) {
      if (res.data && res.data.length) {
        let temp = null;
        for (const item of res.data) {
          temp = this.contacts.find((o: any) => o.name === item.deptName);
          if (!temp) {
            temp = { name: item.deptName, users: [] };
            this.contacts.push(temp);
          }
          temp.users.push(item);
        }
      }
    }
  }

  private async goto(obj: any) {
    switch (obj.type) {
      case "common_link":
        this.$tools.cOpen({ url: obj.link });
        break;
      case "download_link":
        debugger
        console.log(obj.link);
        if(obj.link.indexOf(".pdf")>0){
          window.open(obj.link);
        }else{
          this.$tools.cOpen({ url: obj.link, download: true });
        }
        break;
      case "bpm_workflow_link":
        this.$tools.cOpen({ url: `${env.bpmHost}/Portal/run.html?workflowCode=${obj.link}&formId=&date=&code=${this.currentUser.userNo}` });
        break;
      case "hr_workflow_link":
      case "oa_workflow_link":
      case "ec_link":
        this.$api.GetServiceRoomLink({ type: obj.type, link: obj.link }).then((res: any) => {
          if (res && res.data && Object.keys(res.data)) {
            this._goto(res.data.URL, res.data.openWay);
          }
        });
        break;
      case "preview_link":
        if(obj.link.indexOf(".pdf")>0){
          window.open(obj.link);
        }else{
          window.open(this.$tools.filePreview(obj.link.substr(obj.link.lastIndexOf('/') + 1), obj.link));
        }
        break;
    }
  }
}
